import moment from "moment";

export const formatDateWithoutTimezone = (date, format) => {
  return moment(date).format(format);
};

export const formatDate = (date, format) => {
  return moment
    .utc(date)
    .local()
    .format(format);
};

export const formatDateYearSmall = date => {
  return moment
    .utc(date)
    .local()
    .format("M/D/YY");
};

export const formatDateSmall = date => {
  return moment
    .utc(date)
    .local()
    .format("M/D/YYYY");
};

export const formatDateSmallWithoutTimezone = date => {
  return moment(date).format("M/D/YYYY");
};

export const formatDateMedium = date => {
  return moment
    .utc(date)
    .local()
    .format("MMMM Do, YYYY");
};

export const formatDateLog = date => {
  return moment
    .utc(date)
    .local()
    .format("MM/DD/YY H:mm");
};

export const formatDateLogWithoutTimezone = date => {
  return moment(date).format("MM/DD/YY H:mm");
};

export const formatDateTimeLog = date => {
  return moment
    .utc(date)
    .local()
    .format("MM/DD/YY hh:mm a");
};

export const formatDateTimeLogWithoutTimezone = date => {
  return moment(date).format("MM/DD/YY hh:mm a");
};



// WEBPACK FOOTER //
// ./src/utils/dates.js